export interface Country {
  slug: string;
  code: string;
  nameVi: string;
  nameEn: string;
}

/** Shared hero photo for all country pages. */
export const COUNTRY_HERO_IMAGE =
  "https://imagedelivery.net/nl1TeXQ-vO_JaNX18Y3FBg/0eb92a73-f2a8-47d3-d6fe-f8403dc32200/hero";

export const COUNTRIES: readonly Country[] = [
  { slug: "vietnam", code: "VN", nameVi: "Việt Nam", nameEn: "Vietnam" },
  { slug: "united-states", code: "US", nameVi: "Hoa Kỳ", nameEn: "United States" },
  { slug: "canada", code: "CA", nameVi: "Canada", nameEn: "Canada" },
  { slug: "australia", code: "AU", nameVi: "Úc", nameEn: "Australia" },
  { slug: "new-zealand", code: "NZ", nameVi: "New Zealand", nameEn: "New Zealand" },
  { slug: "united-kingdom", code: "GB", nameVi: "Vương quốc Anh", nameEn: "United Kingdom" },
  { slug: "ireland", code: "IE", nameVi: "Ireland", nameEn: "Ireland" },
  { slug: "germany", code: "DE", nameVi: "Đức", nameEn: "Germany" },
  { slug: "france", code: "FR", nameVi: "Pháp", nameEn: "France" },
  { slug: "netherlands", code: "NL", nameVi: "Hà Lan", nameEn: "Netherlands" },
  { slug: "belgium", code: "BE", nameVi: "Bỉ", nameEn: "Belgium" },
  { slug: "luxembourg", code: "LU", nameVi: "Luxembourg", nameEn: "Luxembourg" },
  { slug: "switzerland", code: "CH", nameVi: "Thụy Sĩ", nameEn: "Switzerland" },
  { slug: "austria", code: "AT", nameVi: "Áo", nameEn: "Austria" },
  { slug: "italy", code: "IT", nameVi: "Ý", nameEn: "Italy" },
  { slug: "spain", code: "ES", nameVi: "Tây Ban Nha", nameEn: "Spain" },
  { slug: "portugal", code: "PT", nameVi: "Bồ Đào Nha", nameEn: "Portugal" },
  { slug: "czech-republic", code: "CZ", nameVi: "Cộng hòa Séc", nameEn: "Czech Republic" },
  { slug: "slovakia", code: "SK", nameVi: "Slovakia", nameEn: "Slovakia" },
  { slug: "poland", code: "PL", nameVi: "Ba Lan", nameEn: "Poland" },
  { slug: "hungary", code: "HU", nameVi: "Hungary", nameEn: "Hungary" },
  { slug: "romania", code: "RO", nameVi: "Romania", nameEn: "Romania" },
  { slug: "bulgaria", code: "BG", nameVi: "Bulgaria", nameEn: "Bulgaria" },
  { slug: "greece", code: "GR", nameVi: "Hy Lạp", nameEn: "Greece" },
  { slug: "croatia", code: "HR", nameVi: "Croatia", nameEn: "Croatia" },
  { slug: "slovenia", code: "SI", nameVi: "Slovenia", nameEn: "Slovenia" },
  { slug: "sweden", code: "SE", nameVi: "Thụy Điển", nameEn: "Sweden" },
  { slug: "norway", code: "NO", nameVi: "Na Uy", nameEn: "Norway" },
  { slug: "denmark", code: "DK", nameVi: "Đan Mạch", nameEn: "Denmark" },
  { slug: "finland", code: "FI", nameVi: "Phần Lan", nameEn: "Finland" },
  { slug: "iceland", code: "IS", nameVi: "Iceland", nameEn: "Iceland" },
  { slug: "estonia", code: "EE", nameVi: "Estonia", nameEn: "Estonia" },
  { slug: "latvia", code: "LV", nameVi: "Latvia", nameEn: "Latvia" },
  { slug: "lithuania", code: "LT", nameVi: "Lithuania", nameEn: "Lithuania" },
  { slug: "russia", code: "RU", nameVi: "Nga", nameEn: "Russia" },
  { slug: "ukraine", code: "UA", nameVi: "Ukraine", nameEn: "Ukraine" },
  { slug: "japan", code: "JP", nameVi: "Nhật Bản", nameEn: "Japan" },
  { slug: "south-korea", code: "KR", nameVi: "Hàn Quốc", nameEn: "South Korea" },
  { slug: "china", code: "CN", nameVi: "Trung Quốc", nameEn: "China" },
  { slug: "taiwan", code: "TW", nameVi: "Đài Loan", nameEn: "Taiwan" },
  { slug: "hong-kong", code: "HK", nameVi: "Hồng Kông", nameEn: "Hong Kong" },
  { slug: "singapore", code: "SG", nameVi: "Singapore", nameEn: "Singapore" },
  { slug: "malaysia", code: "MY", nameVi: "Malaysia", nameEn: "Malaysia" },
  { slug: "thailand", code: "TH", nameVi: "Thái Lan", nameEn: "Thailand" },
  { slug: "indonesia", code: "ID", nameVi: "Indonesia", nameEn: "Indonesia" },
  { slug: "philippines", code: "PH", nameVi: "Philippines", nameEn: "Philippines" },
  { slug: "cambodia", code: "KH", nameVi: "Campuchia", nameEn: "Cambodia" },
  { slug: "laos", code: "LA", nameVi: "Lào", nameEn: "Laos" },
  { slug: "india", code: "IN", nameVi: "Ấn Độ", nameEn: "India" },
  { slug: "brazil", code: "BR", nameVi: "Brazil", nameEn: "Brazil" },
  { slug: "mexico", code: "MX", nameVi: "Mexico", nameEn: "Mexico" },
];

export function getCountryBySlug(slug: string): Country | undefined {
  return COUNTRIES.find((c) => c.slug === slug);
}

export function getCountryByCode(code: string): Country | undefined {
  return COUNTRIES.find((c) => c.code === code);
}

export function countryName(country: Country, locale: "vi" | "en"): string {
  return locale === "en" ? country.nameEn : country.nameVi;
}
